import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { orderQueryConfig } from '../../../query-configs/order'

export const useGetOrderPermissions = ({ orderUuid }: { orderUuid: uuid }) => {
  const { data } = useQuery({
    // Reusing the order details query to get permissions as this is the query that
    // contains the permissions in its metadata
    ...orderQueryConfig.getOrderDetails(orderUuid),
  })

  const permissions = useMemo(
    () => data?.metadata.permissions || null,
    [data?.metadata.permissions]
  )

  return permissions
}
